import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Animated,
  Easing,
  Modal,
  TextInput,
} from "react-native";
import React, { useState, useEffect, useRef } from "react";
import { observer, Observer } from "mobx-react";
import GlobalStyles from "../../../Resources/Styles";
import { VictoryPie } from "victory";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import { Ionicons } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import { Entypo } from "@expo/vector-icons";

import { FontAwesome5 } from "@expo/vector-icons";
import { useScreenDimensions, useDevice } from "../../_layout";

import { FontAwesome } from "@expo/vector-icons";

import { format } from "date-fns";

import IconEmptyView from "../../Components/IconEmptyView";

import { useTranslation } from "react-i18next";

import CustomAlert from "../../Components/CustomAlert";
import Tooltip from "../../Components/Tooltip";
import AddNewClientView from "../../Components/AddNewClientView";
import StripePayment from "../Stripe/StripePayment";
import { ScrollView } from "react-native-web";
import LogoImage from "../../Components/LogoImage";
import OfflineAlert from "../../Components/OfflineAlert";
import SyncStatusIndicator from "../../Components/SyncStatusIndicator";
import CTAButton from "../../Components/CTAButton";
import SearchBar from "../../Components/SearchBar";
import { SyncStatus } from "../../../Resources/Constants";
import { collection, getDocs, limit, query, where } from "firebase/firestore";
import db from "../../Firestore/FirestoreConfig";
import {
  getNextIncompleteTutorialStep,
  getTutorialSteps,
} from "../../utils/tutorialUtils";
import FloatingMenu from "../../Components/FloatingMenu";
import HoverableTouchableOpacity from "../../Components/HoverableTouchableOpacity";
import {
  COACH_DASHBOARD_DELETE_FLOW,
  matchesDeleteConfirmationInput,
  resolveDashboardClientActionPolicy,
} from "../../invitations/coachDashboardClientActions";
import { getCoachDashboardTableColumnWidth } from "./coachDashboardTableLayout";
import {
  resolveDashboardBlockDisplay,
  resolveDashboardWeekDisplay,
  resolveDashboardWeekWorkoutsDisplay,
} from "./coachDashboardClientRowPresentation";
import {
  getPendingAthletesCardMetrics,
  getPendingBlockUpdateCardMetrics,
  getPendingNewBlockCardMetrics,
} from "./coachDashboardSummaryCardSelectors";
import { isWorkablePendingWorkspaceClient } from "../../invitations/pendingWorkspaceState";

const DEBUG_FORCE_MOBILE_NEXT_STEP_CARD = false;

const CoachDashboard = ({ coach, showClient }) => {
  const { t, i18n } = useTranslation();

  const { isMobile } = useDevice();

  const { screenSize } = useScreenDimensions();
  const [showingAddClient, setShowingAddClient] = useState(false);

  const [showingStripePayment, setShowingStripePayment] = useState(false);
  const [showingMaxClientsReached, setShowingMaxClientsReached] =
    useState(false);
  const [showingMaxClientsTrial, setShowingMaxClientsTrial] = useState(false);

  const [deleteAlertConfig, setDeleteAlertConfig] = useState(null);
  const [typedDeleteConfig, setTypedDeleteConfig] = useState(null);
  const [typedDeleteValue, setTypedDeleteValue] = useState("");

  const [showingOfflineAlert, setShowingOfflineAlert] = useState(false);

  const gap = screenSize === "small" ? 8 : 24;

  const closeDeleteDialogs = () => {
    setDeleteAlertConfig(null);
    setTypedDeleteConfig(null);
    setTypedDeleteValue("");
  };

  const runDeleteAction = async ({ client, deleteEntity }) => {
    if (!client) return;
    if (deleteEntity === "athlete") {
      await client.deleteClient();
      return;
    }
    await client.deleteInvitation();
  };

  const openLegacyInvitationDeleteWarning = ({ client }) => {
    setDeleteAlertConfig({
      client,
      deleteEntity: "invitation",
      titleKey: "deleteInvitationAlertTitle-string",
      textKey: "deleteInvitationAlertText-string",
    });
  };

  const openDeleteDialogForClient = ({
    client,
    forceLegacyWarning = false,
  }) => {
    const actionPolicy = resolveDashboardClientActionPolicy({
      client,
    });

    if (forceLegacyWarning || actionPolicy.isLegacyNonOpenableInvitation) {
      openLegacyInvitationDeleteWarning({ client });
      return;
    }

    if (
      actionPolicy.deleteFlow ===
      COACH_DASHBOARD_DELETE_FLOW.INVITATION_ONE_CLICK
    ) {
      setDeleteAlertConfig({
        client,
        deleteEntity: "invitation",
        titleKey: "deleteInvitationAlertTitle-string",
        textKey: "deleteInvitationAlertText-string",
      });
      return;
    }

    if (
      actionPolicy.deleteFlow ===
      COACH_DASHBOARD_DELETE_FLOW.INVITATION_TYPED_EMAIL
    ) {
      setTypedDeleteConfig({
        client,
        deleteEntity: "invitation",
        expectedValue: actionPolicy.expectedTypedValue,
        titleKey: "deleteInvitationAlertTitle-string",
        textKey: "deleteInvitationAlertText-string",
        instructionKey: "coachDashboardTypeToConfirmDelete-string",
        instructionVariables: {
          expectedValue: actionPolicy.expectedTypedValue,
        },
        placeholderKey: "coachDashboardDeleteInvitationEmailPlaceholder-string",
      });
      setTypedDeleteValue("");
      return;
    }

    const athleteExpectedValue = actionPolicy.expectedTypedValue;
    setTypedDeleteConfig({
      client,
      deleteEntity: "athlete",
      expectedValue: athleteExpectedValue,
      titleKey: "deleteClientAlertTitle-string",
      textKey: "deleteClientAlertText-string",
      instructionKey: "coachDashboardTypeToConfirmDelete-string",
      instructionVariables: {
        expectedValue: athleteExpectedValue,
      },
      placeholderKey: "coachDashboardDeleteAthleteNamePlaceholder-string",
    });
    setTypedDeleteValue("");
  };

  const fetchPolClient = async () => {
    try {
      // Build the Firestore query to find the user by email, limited to one document
      const clientsQuery = query(
        collection(db, "users"),
        where("email", "==", "pol.cortess@gmail.com"),
        limit(1),
      );

      // Execute the query
      const querySnapshot = await getDocs(clientsQuery);

      if (querySnapshot.empty) {
        throw new Error("Client not found");
      }

      // Extract the single matching document
      const doc = querySnapshot.docs[0];
      const clientData = doc.data();

      // Use the coach service to fetch the full client object
      const newClient = await coach.fetchClient(clientData);
      return newClient;
    } catch (error) {
      console.error("Error fetching Pol client:", error);
      throw error;
    }
  };

  const selectClient = (selectedClient) => {
    const clientId = selectedClient?.id;
    if (!clientId) return;

    coach.dismissInviteBlockNudge?.();
    coach.setProperty("selectedClientId", clientId);
    if (selectedClient?.usePendingBlocksPath === true) {
      selectedClient.setProperty("selectedTab", "planification-string");
    }
    showClient();
    coach.fetchNewClient(clientId, t, i18n.language);
  };

  const openProgramFromTutorial = async () => {
    if (coach.activeClients.length === 0) {
      setShowingAddClient(true);
      return;
    }

    coach.setProperty("showingCoachView", "ClientDashboard");

    if (coach.onboardingShowBlock) {
      coach.setProperty("highlightedComponent", "AddRow");
    }

    const selectedClient =
      coach.activeClients.find(
        (client) => client.id === coach.selectedClientId,
      ) ||
      coach.activeClients.find(
        (client) => !client.email.includes("efortcoach"),
      ) ||
      coach.activeClients[0];

    if (!selectedClient) return;

    coach.setProperty("selectedClientId", selectedClient.id);
    await coach.fetchNewClient(selectedClient.id, t, i18n.language, true);
    selectedClient.setProperty("selectedTab", "planification-string");

    if (selectedClient.selectedBlock) {
      selectedClient.selectedBlock.setProperty("isShowingDashboard", false);
    } else if (selectedClient.sortedBlocks?.length > 0) {
      const firstBlock = selectedClient.sortedBlocks[0];
      selectedClient.setSelectedBlock(firstBlock);
      firstBlock.setProperty("selectedWeek", firstBlock.getWeeks);
      firstBlock.setProperty("isShowingDashboard", false);
    }
  };

  const runTutorialStepAction = async (actionType) => {
    if (coach.isOffline || !coach.isActive) return;

    if (actionType === "block") {
      await openProgramFromTutorial();
      return;
    }

    if (actionType === "app") {
      coach.setProperty("showingAthleteAppOnboarding", true);
      return;
    }

    if (actionType === "client") {
      setShowingAddClient(true);
    }
  };

  useEffect(() => {
    coach.setProperty("searchTerm", "");
    coach.setProperty("sortTerm", "client");
    return () => coach.setProperty("searchTerm", "");
  }, []);

  const QuestionMark = ({ graph }) => {
    const tooltip = graph
      ? "dashboardBlockToCreateTooltip-string"
      : "dashboardWeekToUpdateTooltip-string";

    return (
      <Tooltip content={tooltip} placement="top" maxWidth={300}>
        <View style={[styles.tooltipIconContainer, {}]}>
          <Ionicons
            name="information-circle-outline"
            size={18}
            color={Colors.grayColor}
          />
        </View>
      </Tooltip>
    );
  };

  const CheckedClients = observer(() => {
    const summaryMetrics = getPendingAthletesCardMetrics(coach?.clients);

    const Legend = () => {
      return (
        <>
          <View style={[styles.legendItem]}>
            <View
              style={[
                styles.colorCircle,
                { backgroundColor: Colors.bubbleColor },
              ]}
            />
            <Text
              style={[
                Fonts.regular12,
                { fontSize: 11, color: Colors.blackColor },
              ]}
            >
              {t("completedClients-string")}
            </Text>
          </View>
          <View style={[styles.legendItem, { marginTop: 8 }]}>
            <View
              style={[
                styles.colorCircle,
                { backgroundColor: Colors.grayColor },
              ]}
            />
            <Text
              style={[
                Fonts.regular12,
                { fontSize: 11, color: Colors.blackColor },
              ]}
            >
              {t("pendingClients-string")}
            </Text>
          </View>
        </>
      );
    };

    return (
      <View
        style={{
          backgroundColor: "white",
          height: "100%",
          borderRadius: 14,
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          justifyContent: "space-between",
        }}
      >
        <Text style={[styles.subtitle, { paddingTop: 12, paddingLeft: 14 }]}>
          {t("pendingClients-string")}
        </Text>
        <View
          style={[
            GlobalStyles.HStack,
            {
              alignItems: "center",
              justifyContent: "space-evenly",
              paddingBottom: 10,
              height: "100%",
              marginTop: -10,
            },
          ]}
        >
          <View>
            <View
              style={[
                GlobalStyles.HStack,
                {
                  paddingBottom: 20,
                  marginLeft: 22,
                },
              ]}
            >
              <Text style={[{ fontSize: 50 }]}>
                {summaryMetrics.pendingCount}{" "}
              </Text>
              <Text
                style={[
                  { fontSize: 38, alignSelf: "flex-end", paddingBottom: 2 },
                ]}
              >
                /{" "}
              </Text>
              <Text style={[{ fontSize: 30, alignSelf: "flex-end" }]}>
                {summaryMetrics.totalCount}
              </Text>
              <View />
            </View>
          </View>
          <View
            style={[
              {
                width: "35%",
                maxHeight: 155,
                maxWidth: 155,
                zIndex: -2,
                // borderWidth: 2,
                marginBottom: 18,
              },
            ]}
          >
            <VictoryPie
              data={[
                {
                  x: "",
                  y: summaryMetrics.checkedCount,
                },
                {
                  x: "",
                  y: summaryMetrics.pendingCount,
                },
              ]}
              colorScale={[Colors.bubbleColor, "#D1D5DB"]}
              style={{
                data: {
                  fillOpacity: 1,
                  stroke: "#fff",
                  strokeWidth: 0,
                },
              }}
              labels={() => null}
            />
            <View
              style={{
                position: "absolute",
                zIndex: 1,
                width: "100%",
                height: "100%",
              }}
            />
          </View>

          {screenSize === "large" && (
            <View
              style={{
                maxWidth: "25%",
                marginBottom: 8,
              }}
            >
              <Legend />
            </View>
          )}
        </View>
      </View>
    );
  });

  const LastWeekClients = observer(() => {
    const summaryMetrics = getPendingNewBlockCardMetrics(coach?.clients);

    return (
      <View
        style={{
          flex: 1,
          flexGrow: 1,
          height: "100%",
          borderRadius: 14,
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          backgroundColor: Colors.whiteColor,
          justifyContent: "space-between",
          paddingVertical: 12,
        }}
      >
        <View
          style={[
            GlobalStyles.HStack,
            {
              width: "100%",
              paddingHorizontal: 14,
              justifyContent: "space-between",
            },
          ]}
        >
          <Text style={[styles.subtitle, { marginRight: 4 }]} numberOfLines={2}>
            {t("clientsWithBlockToCreate-string")}
          </Text>
          <QuestionMark graph={true} />
        </View>
        <Text
          style={[
            {
              fontSize: 30,
              marginBottom: -2,
              backgroundColor: "white",
              paddingHorizontal: 24,
            },
          ]}
        >
          {summaryMetrics.pendingCount}
        </Text>
        <View
          style={[
            {
              width: "100%",
              paddingHorizontal: 14,
              marginTop: 2,
              marginBottom: 2,
            },
          ]}
        >
          <View
            style={{
              height: 8,
              width: "100%",
              backgroundColor: "#D1D5DB",
              borderRadius: 6,
              flexDirection: "row",
              overflow: "hidden",
            }}
          >
            <View
              style={{
                height: "100%",
                width: `${summaryMetrics.progress * 100}%`,
                backgroundColor: Colors.bubbleColor,
                borderRadius: 6,
              }}
            />
          </View>
        </View>
      </View>
    );
  });

  const PreviousWeekClients = observer(() => {
    const summaryMetrics = getPendingBlockUpdateCardMetrics(coach?.clients);

    return (
      <View
        style={{
          flex: 1,
          height: "100%",
          borderRadius: 14,
          borderWidth: 0.1,
          borderColor: Colors.borderColor,
          backgroundColor: Colors.whiteColor,
          paddingVertical: 12,
          justifyContent: "space-between",
        }}
      >
        <View
          style={[
            GlobalStyles.HStack,
            {
              width: "100%",
              paddingHorizontal: 14,
              justifyContent: "space-between",
            },
          ]}
        >
          <Text style={[styles.subtitle, { marginRight: 4 }]} numberOfLines={2}>
            {t("clientsWithWeekToUpdate-string")}
          </Text>
          <QuestionMark graph={false} />
        </View>
        <Text
          style={[{ fontSize: 30, marginHorizontal: 24, marginBottom: -2 }]}
        >
          {summaryMetrics.pendingCount}
        </Text>
        <View
          style={[
            {
              width: "100%",
              paddingHorizontal: 14,
              marginTop: 2,
              marginBottom: 2,
            },
          ]}
        >
          <View
            style={{
              height: 8,
              width: "100%",
              backgroundColor: "#D1D5DB",
              borderRadius: 6,
              flexDirection: "row",
              overflow: "hidden",
            }}
          >
            <View
              style={{
                height: "100%",
                width: `${summaryMetrics.progress * 100}%`,
                backgroundColor: Colors.bubbleColor,
                borderRadius: 6,
              }}
            />
          </View>
        </View>
      </View>
    );
  });

  const NextCompetitions = observer(() => {
    const CompetitionRow = observer(({ competition }) => {
      const [isHovered, setIsHovered] = useState(false);
      const action = () => {
        if (coach.isActive) {
          if (coach.headCoach) {
            coach.headCoach.setProperty(
              "showingCoachView",
              "CoachCompetitions",
            );
          } else {
            competition.setProperty("isShown", true);
            coach.setProperty("showingCoachView", "CoachCompetitions");
          }
          coach.setProperty("sideMenuVisible", false);
          coach.unselectClient();
        }
      };
      return (
        <TouchableOpacity
          onPress={action}
          style={[
            styles.competitionRow,
            {
              borderColor: isHovered
                ? "rgba(0, 0, 0, 0.5)"
                : "rgba(0, 0, 0, 0.06)",
            },
          ]}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              width: "100%",
              height: screenSize !== "small" ? 71 : 64,
              alignItems: "center",
              justifyContent: "center",
              paddingHorizontal: screenSize === "small" ? 10 : 12,
              justifyContent: "space-between",
              paddingVertical: screenSize === "small" ? 8 : 10,
            }}
          >
            <Text
              numberOfLines={2}
              style={[
                screenSize === "small" ? Fonts.medium14 : Fonts.medium16,
                {
                  width: "100%",
                },
              ]}
            >
              {competition.name}
            </Text>
            <View
              style={[GlobalStyles.HStack, { width: "100%", flexWrap: "wrap" }]}
            >
              <View style={[GlobalStyles.HStack]}>
                <Ionicons
                  name="calendar"
                  size={screenSize === "small" ? 12 : 12}
                  color={Colors.bubbleColor}
                  style={GlobalStyles.rowIcon}
                />
                <Text
                  style={{
                    marginRight: screenSize === "small" ? 8 : 16,
                    fontSize: screenSize === "small" ? 12 : 12,
                    color: Colors.grayColor,
                  }}
                >
                  {screenSize !== "large"
                    ? `${competition.weeksOut(t)}`
                    : `${format(
                        competition.date,
                        "dd/MM/yyyy",
                      )} - ${competition.weeksOut(t)}`}
                </Text>
              </View>
              <View style={[GlobalStyles.HStack]}>
                <FontAwesome5
                  name="clipboard-list"
                  size={screenSize === "small" ? 12 : 12}
                  color={Colors.bubbleColor}
                  style={GlobalStyles.rowIcon}
                />
                <Text
                  style={{
                    marginRight: screenSize === "small" ? 8 : 16,
                    fontSize: screenSize === "small" ? 12 : 12,
                    color: Colors.grayColor,
                  }}
                >
                  {competition.competitionClass}
                </Text>
              </View>
              <View style={[GlobalStyles.HStack]}>
                <Ionicons
                  name="podium"
                  size={screenSize === "small" ? 12 : 12}
                  color={Colors.bubbleColor}
                  style={GlobalStyles.rowIcon}
                />
                <Text
                  style={{
                    marginRight: screenSize === "small" ? 8 : 16,
                    fontSize: screenSize === "small" ? 12 : 12,
                    color: Colors.grayColor,
                  }}
                >
                  {competition.competitionLevel}
                </Text>
              </View>
              <View style={[GlobalStyles.HStack]}>
                <Ionicons
                  name="person"
                  size={screenSize === "small" ? 12 : 12}
                  color={Colors.bubbleColor}
                  style={GlobalStyles.rowIcon}
                />
                <Text
                  style={{
                    marginRight: screenSize === "small" ? 8 : 16,
                    fontSize: screenSize === "small" ? 12 : 12,
                    color: Colors.grayColor,
                  }}
                  numberOfLines={1}
                >
                  {coach.clientsInComp(competition).length === 1
                    ? t("athleteCountOne-string", {
                        count: coach.clientsInComp(competition).length,
                      })
                    : t("athleteCount-string", {
                        count: coach.clientsInComp(competition).length,
                      })}
                </Text>
              </View>
            </View>
          </View>
        </TouchableOpacity>
      );
    });
    return (
      (coach.getFutureCompetitions.length > 0 || screenSize !== "small") && (
        <View
          style={[
            {
              width: screenSize !== "small" ? "100%" : "100%",
              backgroundColor: "white",
              height: screenSize === "small" ? 180 : "100%",
              marginTop: screenSize === "small" ? 8 : 0,
              borderRadius: 14,
              borderWidth: 0.1,
              borderColor: Colors.borderColor,
              paddingBottom: 14,
            },
          ]}
        >
          <Text
            style={[styles.subtitle, { paddingVertical: 12, paddingLeft: 14 }]}
          >
            {t("nextCompetitions-string")}
          </Text>

          {coach.getFutureCompetitions.length > 0 ? (
            <ScrollView
              style={{ flex: 1 }}
              showsVerticalScrollIndicator={false}
              contentContainerStyle={{ gap: 12 }}
            >
              {coach.getFutureCompetitions.map((competition, index) => (
                <CompetitionRow
                  competition={competition}
                  key={competition.id}
                  lastInRow={coach.getFutureCompetitions.length - 1 === index}
                />
              ))}
            </ScrollView>
          ) : (
            <IconEmptyView
              iconLibrary={"Ionicons"}
              mainText={"emptyCompetitionsTitle-string"}
              subText={"emptyCompetitionsText-string"}
              iconName={"calendar"}
              marginTop={0}
            />
          )}
        </View>
      )
    );
  });

  const ClientsTable = () => {
    const ClientTableHeader = observer(() => {
      return (
        <View
          style={{
            flex: 1,
            marginTop: screenSize === "small" ? 8 : 12,
            paddingVertical: 6,
            backgroundColor: Colors.lightGrayColor,
            borderTopLeftRadius: 14,
            borderTopRightRadius: 14,
            borderWidth: 0.1,
            borderColor: Colors.borderColor,
            alignItems: "center",
          }}
        >
          <View
            style={{
              ...GlobalStyles.HStack,
              width: "100%",
              flex: 1,
              height: "100%",
              // justifyContent: "space-between",
              paddingHorizontal: 10,
            }}
          >
            {[
              {
                key: "client",
                label: t("clientHeader-string"),
                width: getCoachDashboardTableColumnWidth("client"),
              },
              {
                key: "block",
                label: t("blockHeader-string"),
                width: getCoachDashboardTableColumnWidth("block"),
              },
              {
                key: "week",
                label: t("weekHeader-string"),
                width: getCoachDashboardTableColumnWidth("week"),
              },
            ].map(({ key, label, width }) => (
              <TouchableOpacity
                key={key}
                onPress={() => coach.setProperty("sortTerm", key)}
                style={{
                  width,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FontAwesome
                  name="sort"
                  size={12}
                  color="rgb(108, 115, 127)"
                  style={{ marginRight: 5, opacity: 0 }}
                />
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 14,
                    fontWeight: "600",
                    color: "rgb(108, 115, 127)",
                  }}
                >
                  {label}
                </Text>
                <FontAwesome
                  name="sort"
                  size={12}
                  color="rgb(108, 115, 127)"
                  style={{
                    marginLeft: 5,
                    opacity: coach.sortTerm === key ? 1 : 0,
                  }}
                />
              </TouchableOpacity>
            ))}

            <View
              style={{
                width: getCoachDashboardTableColumnWidth("workouts"),
                alignItems: "center",
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    textAlign: "center",
                    fontSize: 14,
                    fontWeight: "600",
                    color: "rgb(108, 115, 127)",
                  }}
                >
                  {t("workoutsOfWeekHeader-string")}
                </Text>
                <Tooltip
                  content="workoutsOfWeekTooltip-string"
                  placement="top"
                  maxWidth={300}
                >
                  <View
                    style={[styles.tooltipIconContainer, { marginLeft: 4 }]}
                  >
                    <Ionicons
                      name="information-circle-outline"
                      size={16}
                      color={"rgb(108, 115, 127)"}
                    />
                  </View>
                </Tooltip>
              </View>
              <View
                style={{
                  height: 1,
                  backgroundColor: Colors.borderColor,
                  width: "100%",
                  marginVertical: 5,
                }}
              />
              <View
                style={{
                  ...GlobalStyles.HStack,
                  width: "100%",
                }}
              >
                {["mon", "tue", "wed", "thu", "fri", "sat", "sun"].map(
                  (day) => (
                    <TouchableOpacity
                      key={day}
                      onPress={() =>
                        coach && coach.setProperty("sortTerm", day)
                      }
                      style={{
                        width: "14.28%",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <FontAwesome
                        name="sort"
                        size={12}
                        color="rgb(108, 115, 127)"
                        style={{
                          marginRight: 5,
                          opacity: 0,
                        }}
                      />
                      <Text
                        style={{
                          textAlign: "center",
                          fontSize: 12,
                          fontWeight: "600",
                          color: "rgb(108, 115, 127)",
                        }}
                      >
                        {t(`${day}Header-string`).toUpperCase()}
                      </Text>
                      <FontAwesome
                        name="sort"
                        size={12}
                        color="rgb(108, 115, 127)"
                        style={{
                          marginLeft: 5,
                          opacity: coach.sortTerm === day ? 1 : 0,
                        }}
                      />
                    </TouchableOpacity>
                  ),
                )}
              </View>
            </View>

            <TouchableOpacity
              onPress={() => coach.setProperty("sortTerm", "status")}
              style={{
                width: getCoachDashboardTableColumnWidth("status"),
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FontAwesome
                name="sort"
                size={12}
                color="rgb(108, 115, 127)"
                style={{ marginRight: 5, opacity: 0 }}
              />
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 14,
                  fontWeight: "600",
                  color: "rgb(108, 115, 127)",
                }}
              >
                {t("statusHeader-string")}
              </Text>
              <FontAwesome
                name="sort"
                size={12}
                color="rgb(108, 115, 127)"
                style={{
                  marginLeft: 5,
                  opacity: coach.sortTerm === "status" ? 1 : 0,
                }}
              />
            </TouchableOpacity>
            <View
              style={{
                width: getCoachDashboardTableColumnWidth("actions"),
              }}
            />
          </View>
        </View>
      );
    });

    const EmptySearchState = () => {
      return (
        <View
          style={{
            backgroundColor: "white",
            borderBottomRightRadius: 14,
            borderBottomLeftRadius: 14,
            borderRightWidth: 0.1,
            borderLeftWidth: 0.1,
            borderBottomWidth: 0.1,
            borderColor: Colors.borderColor,
          }}
        >
          <IconEmptyView
            iconLibrary={"Ionicons"}
            mainText={"emptyClientsTitle-string"}
            subText={"noAthletesFoundText-string"}
            iconName={"search-outline"}
            marginTop={48}
            marginBottom={16}
          />
        </View>
      );
    };

    const ClientRow = observer(({ client, index }) => {
      const actionPolicy = resolveDashboardClientActionPolicy({
        client,
      });
      const blockDisplay = resolveDashboardBlockDisplay(client);
      const weekDisplay = resolveDashboardWeekDisplay(client);
      const weekWorkoutsDisplay = resolveDashboardWeekWorkoutsDisplay(client);
      const isUnavailableBySideMenuRule = client?.isOfflineSelectable !== true;

      const rowMenuItems = [
        {
          key: "open",
          label: t("openAthlete-string"),
          icon: "open-outline",
          disabled: !actionPolicy.canOpen,
          isDanger: false,
        },
        {
          key: "delete",
          label: t(actionPolicy.deleteLabelKey),
          icon: "trash-outline",
          disabled: false,
          isDanger: true,
        },
      ];

      const RenderCircles = observer(() => {
        return weekWorkoutsDisplay.weekWorkouts.map(
          (hasWorkout, workoutIndex) => {
            let circleStyle = {
              borderWidth: 0.5,
              borderColor: Colors.bubbleColor,
              backgroundColor: "transparent",
            };

            if (weekWorkoutsDisplay.readOnly) {
              circleStyle = {
                borderWidth: 1,
                borderColor: Colors.grayColor,
                backgroundColor: "transparent",
              };
            } else if (hasWorkout) {
              circleStyle.backgroundColor = Colors.bubbleColor;
            } else {
              circleStyle.borderWidth = 1;
            }

            const toggleWorkoutDay = () => {
              if (coach.isActive && !coach.isOffline) {
                const previousWorkouts = [...weekWorkoutsDisplay.weekWorkouts];
                const updatedWorkouts = [...weekWorkoutsDisplay.weekWorkouts];
                updatedWorkouts[workoutIndex] = !updatedWorkouts[workoutIndex];
                client.setProperty("weekWorkouts", updatedWorkouts);

                if (client.status === "active-string") {
                  client
                    .uploadData({
                      week_workouts: updatedWorkouts,
                    })
                    .catch((error) => {
                      client.setProperty("weekWorkouts", previousWorkouts);
                      console.warn(
                        "[coach-dashboard] failed to persist active week_workouts",
                        client?.id,
                        error,
                      );
                    });
                  return;
                }

                if (isWorkablePendingWorkspaceClient(client)) {
                  client
                    .persistPendingWorkspaceWeekWorkouts(updatedWorkouts)
                    .catch((error) => {
                      client.setProperty("weekWorkouts", previousWorkouts);
                      console.warn(
                        "[coach-dashboard] failed to persist pending week_workouts",
                        client?.id,
                        error,
                      );
                    });
                  return;
                }

                client.setProperty("weekWorkouts", previousWorkouts);
              }
            };

            const [isHovered, setIsHovered] = useState(false);

            return (
              <TouchableOpacity
                key={workoutIndex}
                onPress={(event) => {
                  if (weekWorkoutsDisplay.readOnly) {
                    event?.stopPropagation?.();
                    return;
                  }
                  toggleWorkoutDay();
                }}
                style={{
                  flexDirection: "row",
                  height: "100%",
                  width: "14.28%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onMouseEnter={() => !isMobile && setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <View
                  style={[
                    styles.circle,
                    circleStyle,
                    {
                      opacity: weekWorkoutsDisplay.readOnly
                        ? 0.45
                        : isHovered
                          ? 0.8
                          : 1,
                    },
                  ]}
                />
              </TouchableOpacity>
            );
          },
        );
      });

      const openClientFromDashboard = () => {
        if (actionPolicy.canOpen) {
          selectClient(client);
          return;
        }

        if (actionPolicy.isLegacyNonOpenableInvitation) {
          openLegacyInvitationDeleteWarning({ client });
        }
      };

      const handleMenuAction = (key) => {
        if (!coach.isActive) return;
        if (!client.isAvailable) {
          setShowingOfflineAlert(true);
          return;
        }

        if (key === "open") {
          if (actionPolicy.canOpen) {
            selectClient(client);
          }
          return;
        }

        openDeleteDialogForClient({
          client,
          forceLegacyWarning: actionPolicy.isLegacyNonOpenableInvitation,
        });
      };

      const clientSelection = () => {
        if (!coach.isActive) return;
        if (!client.isAvailable) {
          setShowingOfflineAlert(true);
          return;
        }

        openClientFromDashboard();
      };

      const isLastRow = index === coach.getFilteredClients().length - 1;
      const [isHovered, setIsHovered] = useState(false);
      const [isMenuHovered, setIsMenuHovered] = useState(false);

      return (
        <TouchableOpacity
          onPress={clientSelection}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              backgroundColor: isHovered ? Colors.hoveredGray : "white",
              height: 50,
              borderBottomRightRadius: isLastRow ? 14 : 0,
              borderBottomLeftRadius: isLastRow ? 14 : 0,
              borderTopWidth: index === 0 ? 0 : 0.1,
              borderRightWidth: 0.1,
              borderLeftWidth: 0.1,
              borderBottomWidth: isLastRow ? 0.1 : 0,
              borderColor: Colors.borderColor,
              alignItems: "center",
            }}
          >
            <View
              style={[
                GlobalStyles.HStack,
                {
                  width: "100%",
                  paddingHorizontal: 10,
                  flex: 1,
                  opacity: isUnavailableBySideMenuRule ? 0.5 : 1,
                },
              ]}
            >
              <View
                style={{ width: getCoachDashboardTableColumnWidth("client") }}
              >
                <Text
                  style={[
                    Fonts.regular12,
                    {
                      textAlign: "center",
                      color: Colors.blackColor,
                      fontWeight: "500",
                    },
                  ]}
                  numberOfLines={2}
                >
                  {client.nameForCoach} {client.surnameForCoach}
                </Text>
              </View>

              <View
                style={{ width: getCoachDashboardTableColumnWidth("block") }}
              >
                <Text
                  style={[
                    Fonts.regular12,
                    {
                      textAlign: "center",
                      color: blockDisplay.hasValue
                        ? Colors.blackColor
                        : Colors.grayColor,
                      fontWeight: "500",
                    },
                  ]}
                  numberOfLines={1}
                >
                  {blockDisplay.label}
                </Text>
              </View>

              <View
                style={{ width: getCoachDashboardTableColumnWidth("week") }}
              >
                <Text
                  style={[
                    Fonts.regular12,
                    {
                      textAlign: "center",
                      color: weekDisplay.hasValue
                        ? Colors.blackColor
                        : Colors.grayColor,
                      fontWeight: "500",
                    },
                  ]}
                >
                  {weekDisplay.label}
                </Text>
              </View>

              <View
                style={[
                  GlobalStyles.HStack,
                  {
                    width: getCoachDashboardTableColumnWidth("workouts"),
                  },
                ]}
              >
                <RenderCircles />
              </View>
              <View
                style={{
                  width: getCoachDashboardTableColumnWidth("status"),
                  alignItems: "center",
                }}
              >
                {(() => {
                  const StatusPill = () => {
                    const isActive = client.status === "active-string";
                    const isError = client.status === "error-string";
                    const isPending = client.status === "pending-string";

                    let color, backgroundColor;

                    if (isActive) {
                      color = "#15803d";
                      backgroundColor = "rgba(22, 163, 74, 0.1)";
                    } else if (isError) {
                      color = "#b91c1c";
                      backgroundColor = "rgba(220, 38, 38, 0.1)";
                    } else if (isPending) {
                      color = "#d97706";
                      backgroundColor = "rgba(234, 179, 8, 0.1)";
                    }

                    const pillContent = (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          backgroundColor: backgroundColor,
                          paddingHorizontal: 8,
                          paddingVertical: 4,
                          borderRadius: 10,
                        }}
                      >
                        <View
                          style={{
                            width: 6,
                            height: 6,
                            borderRadius: 3,
                            backgroundColor: color,
                            marginRight: 6,
                          }}
                        />
                        <Text
                          style={[
                            Fonts.regular12,
                            {
                              color: color,
                              fontWeight: "500",
                            },
                          ]}
                        >
                          {isActive
                            ? t("active-string")
                            : isError
                              ? t("error-string")
                              : t("pending-string")}
                        </Text>
                      </View>
                    );

                    if (isError) {
                      return (
                        <Tooltip
                          content="invitationErrorTooltip-string"
                          placement="top"
                          maxWidth={300}
                        >
                          {pillContent}
                        </Tooltip>
                      );
                    }

                    if (isPending) {
                      return (
                        <Tooltip
                          content="invitationPendingTooltip-string"
                          placement="top"
                          maxWidth={300}
                        >
                          {pillContent}
                        </Tooltip>
                      );
                    }

                    return pillContent;
                  };

                  return <StatusPill />;
                })()}
              </View>
              <View
                style={{
                  width: getCoachDashboardTableColumnWidth("actions"),
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FloatingMenu
                  placement="bottom-end"
                  width={190}
                  items={rowMenuItems}
                  menuStyle={GlobalStyles.menu}
                  trigger={
                    <View
                      style={styles.clientMenuTriggerHitArea}
                      onMouseEnter={() => !isMobile && setIsMenuHovered(true)}
                      onMouseLeave={() => setIsMenuHovered(false)}
                    >
                      <Entypo
                        name="dots-three-horizontal"
                        size={16}
                        color={
                          isMenuHovered
                            ? Colors.darkgrayColor
                            : Colors.grayColor
                        }
                      />
                    </View>
                  }
                  renderItem={({ item, close }) => {
                    const menuItem = (
                      <HoverableTouchableOpacity
                        disabled={item.disabled}
                        hoverStyle={
                          !item.disabled
                            ? styles.clientMenuItemHover
                            : undefined
                        }
                        onPress={(event) => {
                          event?.stopPropagation?.();
                          if (item.disabled) return;
                          handleMenuAction(item.key);
                          close();
                        }}
                        style={[
                          styles.clientMenuItemRow,
                          item.disabled && styles.clientMenuItemDisabled,
                        ]}
                      >
                        <Ionicons
                          name={item.icon}
                          size={14}
                          color={
                            item.disabled
                              ? Colors.grayColor
                              : item.isDanger
                                ? Colors.redColor
                                : Colors.darkgrayColor
                          }
                        />
                        <Text
                          style={[
                            styles.clientMenuItemText,
                            item.isDanger && styles.clientMenuItemDanger,
                            item.disabled && styles.clientMenuItemTextDisabled,
                          ]}
                        >
                          {item.label}
                        </Text>
                      </HoverableTouchableOpacity>
                    );

                    if (item.key === "open" && item.disabled) {
                      return (
                        <Tooltip
                          content="openAthleteLegacyInvitationTooltip-string"
                          placement="top"
                          maxWidth={260}
                        >
                          <View>{menuItem}</View>
                        </Tooltip>
                      );
                    }

                    return menuItem;
                  }}
                />
              </View>
            </View>
          </View>
        </TouchableOpacity>
      );
    });
    return (
      <ScrollView
        horizontal={true}
        style={{
          width: "100%",
          flexDirection: "row",
        }}
        contentContainerStyle={{ flex: 1 }}
        showsHorizontalScrollIndicator={false}
      >
        <View
          style={{
            minWidth: 800,
            flex: 1,
          }}
        >
          <ClientTableHeader />
          <Observer>
            {() => {
              const filteredClients = coach.getFilteredClients();
              return filteredClients.length > 0 ? (
                filteredClients.map((client, index) => (
                  <View key={client.id}>
                    <ClientRow client={client} key={client.id} index={index} />
                  </View>
                ))
              ) : (
                <EmptySearchState />
              );
            }}
          </Observer>
        </View>
      </ScrollView>
    );
  };

  const MobileNextStepCard = ({
    step,
    isDisabled,
    onPress,
    // remainingSteps removed
  }) => {
    const [isHovered, setIsHovered] = useState(false);
    const pulseAnim = useRef(new Animated.Value(1)).current;
    const shimmerAnim = useRef(new Animated.Value(0)).current;

    useEffect(() => {
      const pulse = Animated.loop(
        Animated.sequence([
          Animated.timing(pulseAnim, {
            toValue: 1.02,
            duration: 1500,
            useNativeDriver: true,
            easing: Easing.inOut(Easing.ease),
          }),
          Animated.timing(pulseAnim, {
            toValue: 1,
            duration: 1500,
            useNativeDriver: true,
            easing: Easing.inOut(Easing.ease),
          }),
        ]),
      );

      const shimmer = Animated.loop(
        Animated.sequence([
          Animated.timing(shimmerAnim, {
            toValue: 1,
            duration: 1200,
            easing: Easing.linear,
            useNativeDriver: false,
          }),
          Animated.delay(1000),
        ]),
      );

      if (!isDisabled) {
        pulse.start();
        shimmer.start();
      }

      return () => {
        pulse.stop();
        shimmer.stop();
      };
    }, [pulseAnim, shimmerAnim, isDisabled]);

    const shimmerTranslate = shimmerAnim.interpolate({
      inputRange: [0, 1],
      outputRange: [-100, 200],
    });

    const renderCtaButton = () => (
      <TouchableOpacity
        onPress={isDisabled ? undefined : onPress}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        activeOpacity={0.7}
        style={{ alignSelf: "flex-start" }}
      >
        <Animated.View
          style={[
            styles.mobileNextStepAction,
            {
              opacity: isDisabled ? 0.5 : isHovered ? 0.9 : 1,
              transform: [
                { scale: isDisabled ? 1 : isHovered ? 1.02 : pulseAnim },
              ],
              overflow: "hidden",
              position: "relative",
            },
          ]}
        >
          <Animated.View
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              width: 80,
              transform: [
                { translateX: shimmerTranslate },
                { skewX: "-20deg" },
              ],
              opacity: 0.3,
            }}
          >
            <LinearGradient
              colors={["transparent", "rgba(255,255,255,0.6)", "transparent"]}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 0 }}
              style={{ flex: 1 }}
            />
          </Animated.View>

          <Text style={styles.mobileNextStepActionText}>{t(step.ctaKey)}</Text>
          <Ionicons name="arrow-forward" size={16} color={Colors.whiteColor} />
        </Animated.View>
      </TouchableOpacity>
    );

    return (
      <View style={{ marginTop: 12, marginBottom: 2, position: "relative" }}>
        <View
          style={{
            backgroundColor: Colors.whiteColor,
            borderTopLeftRadius: 8,
            borderBottomLeftRadius: 8,
            borderTopRightRadius: 14,
            borderBottomRightRadius: 14,
            overflow: "hidden",
            borderWidth: 0.1,
            borderColor: Colors.borderColor,
          }}
        >
          <View
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              bottom: 0,
              width: 4,
              backgroundColor: Colors.bubbleColor,
            }}
          />
          <View style={{ padding: 18, paddingLeft: 22 }}>
            <Text
              style={{
                fontSize: 10,
                fontWeight: "700",
                color: Colors.bubbleColor,
                letterSpacing: 1.5,
                marginBottom: 10,
              }}
            >
              {t("gettingStarted-string").toUpperCase()}
            </Text>
            <Text
              style={{
                fontSize: 18,
                fontWeight: "700",
                color: Colors.blackColor,
                letterSpacing: -0.3,
                marginBottom: 16,
              }}
            >
              {t(step.titleKey)}
            </Text>
            {renderCtaButton()}
          </View>
        </View>
      </View>
    );
  };

  const isTypedDeleteConfirmEnabled =
    typedDeleteConfig &&
    matchesDeleteConfirmationInput({
      input: typedDeleteValue,
      expectedValue: typedDeleteConfig.expectedValue,
    });

  const confirmTypedDelete = async () => {
    if (!typedDeleteConfig || !isTypedDeleteConfirmEnabled) return;
    await runDeleteAction({
      client: typedDeleteConfig.client,
      deleteEntity: typedDeleteConfig.deleteEntity,
    });
    closeDeleteDialogs();
  };

  return (
    <View style={[styles.container, {}]}>
      <View>
        <Observer>
          {() => (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <>
                  <Text
                    style={[
                      styles.title,
                      { marginRight: screenSize === "small" ? 8 : 12 },
                    ]}
                    // onPress={() => coach.changeClientNamesDemo("en", i18n)}
                  >
                    {t("helloCoach-string", { coachName: coach.name })}
                  </Text>
                  {/* <TouchableOpacity onPress={fetchPolClient}>
                    <Text>FETCHPOL</Text>
                  </TouchableOpacity> */}
                  {/* <TouchableOpacity
                    onPress={() => coach.createCoachDemoClient()}
                  >
                    <Text>fetch demo</Text>
                  </TouchableOpacity> */}
                  {coach.syncStatusManager.syncStatus != SyncStatus.SYNCED && (
                    <SyncStatusIndicator
                      syncStatusManager={coach.syncStatusManager}
                      onPress={() => coach.startOrResetBatchTimer()}
                    />
                  )}
                </>
              </View>

              <LogoImage coach={coach} />
            </View>
          )}
        </Observer>

        <Observer>
          {() => {
            const nextStep = getNextIncompleteTutorialStep(coach);
            if (!nextStep) return null;

            const shouldShowCard =
              (isMobile || DEBUG_FORCE_MOBILE_NEXT_STEP_CARD) &&
              !!nextStep.actionType;

            if (!shouldShowCard) return null;

            const remainingSteps = getTutorialSteps(coach).filter(
              (step) => step.actionType && !step.isCompleted,
            ).length;

            return (
              <MobileNextStepCard
                step={nextStep}
                remainingSteps={remainingSteps}
                isDisabled={coach.isOffline || !coach.isActive}
                onPress={() => {
                  void runTutorialStepAction(nextStep.actionType);
                }}
              />
            );
          }}
        </Observer>

        <Observer>
          {() => {
            const showNextCompetitions = coach.showCompetitionsTabInSidebar;
            return (
              <View
                style={[
                  screenSize !== "small" && GlobalStyles.HStack,
                  {
                    justifyContent: "space-between",
                    marginTop: screenSize === "small" ? 12 : 20,
                    marginBottom: screenSize === "small" ? 16 : 24,
                    gap: gap,
                  },
                ]}
              >
                {showNextCompetitions ? (
                  <>
                    <View
                      style={[
                        {
                          flex: 1,
                          width: screenSize === "small" ? "100%" : "50%",
                        },
                      ]}
                    >
                      <View
                        style={{
                          height: screenSize === "small" ? 180 : 180,
                          marginBottom: gap,
                        }}
                      >
                        <CheckedClients />
                      </View>
                      <View
                        style={[
                          GlobalStyles.HStack,
                          {
                            gap: gap,
                            height: 110,
                          },
                        ]}
                      >
                        <View
                          style={{
                            flex: 1,
                            height: "100%",
                          }}
                        >
                          <LastWeekClients />
                        </View>
                        <View
                          style={{
                            flex: 1,
                            height: "100%",
                          }}
                        >
                          <PreviousWeekClients />
                        </View>
                      </View>
                    </View>
                    <View
                      style={{
                        width: screenSize === "small" ? "100%" : "50%",
                        height:
                          screenSize === "small" ? "auto" : 180 + gap + 110,
                      }}
                    >
                      <NextCompetitions />
                    </View>
                  </>
                ) : (
                  <>
                    <View
                      style={[
                        {
                          flex: 1.3,
                          height: screenSize === "small" ? "auto" : "100%",
                        },
                      ]}
                    >
                      <CheckedClients />
                    </View>
                    <View style={screenSize !== "small" ? { flex: 1 } : {}}>
                      <View
                        style={{
                          height: 100,
                          marginBottom: gap,
                        }}
                      >
                        <LastWeekClients />
                      </View>
                      <View
                        style={{
                          height: 100,
                        }}
                      >
                        <PreviousWeekClients />
                      </View>
                    </View>
                  </>
                )}
              </View>
            );
          }}
        </Observer>

        <View style={[GlobalStyles.HStack, { maxWidth: "60%" }]}>
          <Observer>
            {() => (
              <SearchBar
                text={coach.searchTerm}
                onChangeText={(text) => coach.setSearchTerm(text)}
                dark={false}
                placeholder={"searchClient-string"}
              />
            )}
          </Observer>
          <Observer>
            {() => (
              <CTAButton
                plus={true}
                text={"addClient-string"}
                action={() => {
                  if (coach.isActive && !coach.isOffline) {
                    setShowingAddClient(true);
                  }
                }}
                disabled={coach.isOffline}
              />
            )}
          </Observer>
        </View>
        <ClientsTable />

        {showingOfflineAlert && (
          <OfflineAlert
            isVisible={showingOfflineAlert}
            onClose={() => setShowingOfflineAlert(false)}
          />
        )}

        {showingAddClient && (
          <AddNewClientView
            isVisible={showingAddClient}
            onClose={() => setShowingAddClient(false)}
            coach={coach}
            setShowingMaxClientsReached={() =>
              setShowingMaxClientsReached(true)
            }
            setShowingMaxClientsTrial={() => setShowingMaxClientsTrial(true)}
          />
        )}
        {showingStripePayment && (
          <StripePayment
            isVisible={showingStripePayment}
            onClose={() => setShowingStripePayment(false)}
            coach={coach}
          />
        )}
        {showingMaxClientsReached && (
          <StripePayment
            isVisible={showingMaxClientsReached}
            onClose={() => setShowingMaxClientsReached(false)}
            coach={coach}
            maxClientsReached={true}
          />
        )}
        {showingMaxClientsTrial && (
          <StripePayment
            isVisible={showingMaxClientsTrial}
            onClose={() => setShowingMaxClientsTrial(false)}
            coach={coach}
            maxClientsTrial={true}
          />
        )}
        {deleteAlertConfig && (
          <CustomAlert
            isVisible={!!deleteAlertConfig}
            onClose={closeDeleteDialogs}
            title={deleteAlertConfig.titleKey}
            text={deleteAlertConfig.textKey}
            action={() =>
              runDeleteAction({
                client: deleteAlertConfig.client,
                deleteEntity: deleteAlertConfig.deleteEntity,
              })
            }
            specialCTA={"delete-string"}
          />
        )}

        {typedDeleteConfig && (
          <Modal
            animationType="fade"
            transparent={true}
            visible={!!typedDeleteConfig}
            onRequestClose={closeDeleteDialogs}
          >
            <View style={GlobalStyles.centeredView}>
              <TouchableOpacity
                onPress={closeDeleteDialogs}
                style={GlobalStyles.touchableBackground}
              >
                <View />
              </TouchableOpacity>
              <View
                style={styles.typedDeleteModalContainer}
                onStartShouldSetResponder={() => false}
              >
                <View
                  style={[
                    styles.typedDeleteModalView,
                    {
                      width: screenSize === "small" ? 300 : 400,
                      maxWidth: screenSize === "small" ? 300 : 400,
                    },
                  ]}
                >
                  <Text style={[Fonts.bold18Centered, { marginBottom: 12 }]}>
                    {t(typedDeleteConfig.titleKey)}
                  </Text>

                  <Text style={styles.typedDeleteDescription}>
                    {t(typedDeleteConfig.textKey)}
                  </Text>

                  <Text style={styles.typedDeleteInstruction}>
                    {t(
                      typedDeleteConfig.instructionKey,
                      typedDeleteConfig.instructionVariables,
                    )}
                  </Text>

                  <TextInput
                    style={styles.typedDeleteInput}
                    value={typedDeleteValue}
                    onChangeText={setTypedDeleteValue}
                    onSubmitEditing={() => {
                      void confirmTypedDelete();
                    }}
                    placeholder={t(typedDeleteConfig.placeholderKey)}
                    placeholderTextColor={Colors.grayColor}
                    autoCapitalize="none"
                    autoCorrect={false}
                    maxLength={120}
                  />

                  <View style={styles.typedDeleteActions}>
                    <TouchableOpacity onPress={closeDeleteDialogs}>
                      <View style={styles.typedDeleteCancelButton}>
                        <Text style={styles.typedDeleteCancelButtonText}>
                          {t("cancel-string")}
                        </Text>
                      </View>
                    </TouchableOpacity>
                    <TouchableOpacity
                      onPress={confirmTypedDelete}
                      disabled={!isTypedDeleteConfirmEnabled}
                    >
                      <View
                        style={[
                          styles.typedDeleteConfirmButton,
                          !isTypedDeleteConfirmEnabled &&
                            styles.typedDeleteConfirmButtonDisabled,
                        ]}
                      >
                        <Text style={styles.typedDeleteConfirmButtonText}>
                          {t("delete-string")}
                        </Text>
                      </View>
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
            </View>
          </Modal>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.backgroundColor,
  },
  title: {
    fontSize: 24,
    fontWeight: "600",
  },
  subtitle: {
    fontSize: 14,
    fontWeight: "500",
    color: "rgb(140, 140, 140)",
  },
  tabText: {
    fontSize: 20,
    fontWeight: "500",
  },
  underline: {
    height: 2,
    width: "100%",
    alignSelf: "center",
    marginTop: 5,
  },
  circle: {
    width: 12,
    height: 12,
    borderRadius: 50, // Half of the width/height
    marginHorizontal: 8,
  },
  textInputStyle: {
    flex: 1,
    paddingHorizontal: 10,
    borderRadius: 14,
    borderWidth: 0,
    fontWeight: "400",
    fontSize: 14,
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
    borderRadius: 14,
    height: 40,
  },
  legendItem: {
    flexDirection: "row",
    alignItems: "center",
  },
  colorCircle: {
    width: 8,
    height: 8,
    borderRadius: 7.5,
    marginRight: 5,
  },
  competitionRow: {
    backgroundColor: "rgba(63, 123, 141, 0.04)",
    borderRadius: 12,
    borderWidth: 0.1,
    marginHorizontal: 14,
    // marginBottom: 8,
    justifyContent: "space-between",
    alignItems: "center",
    borderColor: "rgba(0, 0, 0, 0.05)",
  },
  clientMenuItemRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 10,
  },
  clientMenuItemHover: {
    backgroundColor: Colors.hoveredGray,
  },
  clientMenuItemText: {
    fontSize: 12,
    color: Colors.blackColor,
    fontWeight: "500",
  },
  clientMenuItemDanger: {
    color: Colors.redColor,
  },
  clientMenuItemDisabled: {
    opacity: 0.45,
  },
  clientMenuItemTextDisabled: {
    color: Colors.grayColor,
  },
  clientMenuTriggerHitArea: {
    paddingHorizontal: 8,
    paddingVertical: 6,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
  },
  typedDeleteModalContainer: {
    position: "absolute",
  },
  typedDeleteModalView: {
    alignSelf: "center",
    backgroundColor: Colors.whiteColor,
    borderRadius: 18,
    width: 400,
    maxWidth: 400,
    paddingHorizontal: 24,
    paddingVertical: 22,
  },
  typedDeleteDescription: {
    color: Colors.blackColor,
    textAlign: "center",
    marginBottom: 12,
    lineHeight: 20,
  },
  typedDeleteInstruction: {
    color: Colors.grayColor,
    textAlign: "center",
    marginBottom: 12,
    lineHeight: 18,
    fontSize: 12,
  },
  typedDeleteInput: {
    borderWidth: 1,
    borderColor: Colors.borderColor,
    borderRadius: 12,
    paddingHorizontal: 12,
    height: 40,
    outlineStyle: "none",
    color: Colors.blackColor,
  },
  typedDeleteActions: {
    ...GlobalStyles.HStack,
    justifyContent: "space-around",
    marginTop: 18,
  },
  typedDeleteCancelButton: {
    borderRadius: 14,
    borderWidth: 1,
    borderColor: Colors.redColor,
    width: 90,
    height: 35,
    alignItems: "center",
    justifyContent: "center",
  },
  typedDeleteCancelButtonText: {
    color: Colors.redColor,
  },
  typedDeleteConfirmButton: {
    borderRadius: 14,
    borderWidth: 1,
    borderColor: Colors.redColor,
    backgroundColor: Colors.redColor,
    width: 90,
    height: 35,
    alignItems: "center",
    justifyContent: "center",
  },
  typedDeleteConfirmButtonDisabled: {
    opacity: 0.45,
  },
  typedDeleteConfirmButtonText: {
    color: Colors.whiteColor,
  },
  tooltipIconContainer: {
    marginLeft: 8,
    justifyContent: "center",
    alignItems: "center",
  },
  mobileNextStepGradientBorder: {
    borderRadius: 14,
    padding: 2,
    zIndex: 3,
  },
  mobileNextStepContainer: {
    backgroundColor: Colors.whiteColor,
    borderRadius: 14,
    padding: 16,
    overflow: "hidden",
  },
  stackedCardMiddle: {
    position: "absolute",
    bottom: -4,
    left: 4,
    right: -4,
    height: "100%",
    backgroundColor: Colors.whiteColor,
    borderRadius: 14,
    borderWidth: 0.1,
    borderColor: Colors.borderColor,
    zIndex: 2,
    opacity: 0.7,
  },
  stackedCardBottom: {
    position: "absolute",
    bottom: -8,
    left: 8,
    right: -8,
    height: "100%",
    backgroundColor: Colors.whiteColor,
    borderRadius: 14,
    borderWidth: 0.1,
    borderColor: Colors.borderColor,
    zIndex: 1,
    opacity: 0.4,
  },
  mobileNextStepHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },
  mobileNextStepLabel: {
    fontSize: 11,
    fontWeight: "700",
    color: Colors.grayColor,
    letterSpacing: 1,
  },
  mobileNextStepBody: {
    marginBottom: 16,
  },
  mobileNextStepTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: Colors.blackColor,
    marginBottom: 6,
    letterSpacing: -0.3,
  },
  mobileNextStepDescription: {
    fontSize: 14,
    color: Colors.grayColor,
    lineHeight: 20,
    maxWidth: "95%",
  },
  mobileNextStepAction: {
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "flex-start",
    backgroundColor: Colors.bubbleColor,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 10,
  },
  mobileNextStepActionText: {
    fontSize: 14,
    fontWeight: "500",
    color: Colors.whiteColor,
    marginRight: 8,
  },
});

export default CoachDashboard;
